import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  DialogContent,
  FormHelperText,
} from "@mui/material";
import moment from "moment";

// Project imports
import "../../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import { SelectClass } from "../../../../Components/Include/DynamicSelect/DynamicSelect";
import { DialogTitleComp } from "../../../../Utils/Component";
import { SelectDatePicker } from "../../../Include/SelectDatePicker/SelectDatePicker";

import useExamType from "./Hooks/useExamType";
// import SubjectScoreList from "./SubjectScoreList";

export default function ExamTypeForm({
  open,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
  classId,
}) {
  const { t } = useContext(AuthContext);
  // const [required, setRequired] = useState(false);
  // const [subjectScoreData, setSubjectScoreData] = useState([
  //   { score: "", maxScore: "", subjectId: { id: "", title: "" } },
  // ]);

  const validationSchema = Yup.object().shape({
    examName: Yup.string().required(t("required")),
    classId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string().required(t("required")),
    }),
    // scoreIndex: Yup.number().typeError(t("required")).required(t("required")),
    // examDate: Yup.string().required(t("required")),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      examName: "",
      classId: { id: "", title: "" },
      // scoreIndex: "",
      // examDate: "",
      remark: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      // const missingSubjects = subjectScoreData?.filter(
      //   (e) => !parseFloat(e?.maxScore) || !e?.subjectId?.id
      // );

      // if (missingSubjects.length > 0) {
      //   setRequired(true);
      //   return;
      // }

      setLoading(true);
      const payload = {
        ...values,
        classId: values?.classId?.id,
        examDate: moment().format("YYYY-MM-DD"),
        // subjectScore: subjectScoreData.map((e) => ({
        //   maxScore: parseFloat(e?.maxScore),
        //   subjectId: e?.subjectId?.id,
        // })),
      };

      if (dialogTitle === "Create") {
        createExamType({ variables: { input: payload } });
      } else {
        updateExamType({ variables: { id: editData?._id, input: payload } });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    resetForm,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  const { createExamType, loading, updateExamType, setLoading } = useExamType({
    resetForm,
    setRefetch,
    handleClose,
  });

  // console.log("values::", values, classId);

  useEffect(() => {
    if (open) {
      if (dialogTitle === "Update" && editData) {
        setFieldValue("examName", editData?.examName);
        // setFieldValue("scoreIndex", editData?.scoreIndex);
        // setFieldValue("examDate", editData?.examDate);
        setFieldValue("remark", editData?.remark);
        setFieldValue("classId", {
          id: editData?.classId?._id,
          title:
            editData?.classId?.courseId?.khName +
            " " +
            editData?.classId?.className,
        });

        // setSubjectScoreData(
        //   editData?.subjectScore?.map((e) => ({
        //     maxScore: parseFloat(e?.maxScore),
        //     subjectId: {
        //       id: e?.subjectId?._id,
        //       title:
        //         language === "en" ? e?.subjectId?.enName : e?.subjectId?.khName,
        //     },
        //   }))
        // );
      } else {
        resetForm();
        setFieldValue("classId", {
          id: classId,
          title: classId,
        });
        // setSubjectScoreData([
        //   { score: "", maxScore: "", subjectId: { id: "", title: "" } },
        // ]);
      }
    }
  }, [open, classId]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_exam_type")
            : t("modal_title_update_exam_type")
        }
        classTitle="dialog-title"
        classIcon="close-icon"
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_exam_name")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_exam_name")}
                  {...getFieldProps("examName")}
                  error={Boolean(touched.examName && errors.examName)}
                  helperText={touched.examName && errors.examName}
                />
              </Grid>

              {!classId && (
                <Grid item xs={12} md={6}>
                  <Typography className={t("class-name-field-title")}>
                    {t("thead_class")}
                  </Typography>
                  <SelectClass
                    value={values?.classId}
                    onChange={(val) =>
                      setFieldValue("classId", val || { id: "", title: "" })
                    }
                  />
                  {touched.classId?.id && errors.classId?.id && (
                    <FormHelperText error>{errors.classId?.id}</FormHelperText>
                  )}
                </Grid>
              )}

              {/* <Grid item xs={12} md={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.examDate}
                  onChange={(val) => setFieldValue("examDate", val)}
                />
                {touched.examDate && errors.examDate && (
                  <FormHelperText error>{errors.examDate}</FormHelperText>
                )}
              </Grid> */}

              {/* <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_score_index")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  type="number"
                  fullWidth
                  {...getFieldProps("scoreIndex")}
                  error={Boolean(touched.scoreIndex && errors.scoreIndex)}
                  helperText={touched.scoreIndex && errors.scoreIndex}
                />
              </Grid> */}

              {/* <Grid item xs={12}>
                <SubjectScoreList 
                  required={required}
                  subjectScoreData={subjectScoreData}
                  setSubjectScoreData={setSubjectScoreData}
                />
              </Grid> */}

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  rows={2}
                  multiline
                  fullWidth
                  placeholder={t("thead_remark")}
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  className={t("class-btn-create")}
                  disabled={loading}
                >
                  {loading
                    ? t("loading")
                    : dialogTitle === "Update"
                    ? t("update")
                    : t("create")}
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
